import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import PricingFree from './PricingFree';
import PricingPaid from './PricingPaid';

function Pricing() {
  return (
    <>
      <section className="theme-light section m-0 p-0" data-theme="light">
        {/* Start flex container */}
        <div className='fullHeight is-flex is-flex-direction-column is-justify-content-space-between'>
            {/* Navigation and Content */}
            <div>
              <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
                <div className="m-0 p-0 column is-11"><Navigation /></div>
              </div>
              <div className='is-flex is-flex-direction-column is-justify-content-center is-align-items-center main-content'>
                <div className="m-0 px-6 has-text-centered content column is-8-widescreen is-8-desktop is-10-tablet is-12-mobile">
                  <h1 className='pt-4 px-0 pb-0 m-0'>Pricing</h1>
                  <h3 className='py-2 px-0 m-0 is-medium'>Nudgemail makes task management so easy that you wonder why everyone else makes it so hard. Choose the right plan for you. Don't know what you need? Get in touch.</h3>
                </div>
                <div className="m-0 p-0 content columns is-8-fullhd is-8-widescreen is-12-desktop is-12-tablet is-12-mobile is-flex is-flex-wrap-wrap is-flex-direction-rows is-justify-content-center">
                  <div className="m-0 py-1 px-4 column is-4-fullhd is-4-widescreen is-6-desktop is-6-tablet is-12-mobile">
                    <PricingFree />
                  </div>
                  <div className="m-0 py-1 px-4 column is-4-fullhd is-4-widescreen is-6-desktop is-6-tablet is-12-mobile">
                    <PricingPaid />
                  </div>
                </div>
              </div>
            </div>
            
            {/* Footer */}
            <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
              <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
            </div>

          </div> 
          {/* End flex container */}
      </section>
    </>
  );
}

export default Pricing;